module.exports = __webpack_public_path__ + "img/mobile.74c4581.svg";